// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ik-0";
export var optionCard = "_ik-1";